import { createContext } from "react";

export const LawyerContext = createContext();
export const CategoriesContext = createContext();
export const UserContext = createContext();
export const LoadingContext = createContext();
export  const EditedContext = createContext();
export const ContextProcessor = createContext();
